import { inject } from '@angular/core';
import { MatomoRouterInterceptorFn } from 'ngx-matomo-client';

import { MatomoService } from '../services/matomo.service';

export const fullUrlInterceptor: MatomoRouterInterceptorFn = async () => {
  const matomoService = inject(MatomoService);
  // this is needed to ensure that the userId is set before tracking the page view
  await matomoService.readyPromise;
  const { origin, pathname } = window.location;

  matomoService.setCustomUrl(`${origin}${pathname}`);
};
